import { createSlice } from "@reduxjs/toolkit";

export const userProSlice = createSlice({
  name: "userPro",
  initialState: {
    userPro: null,
  },
  reducers: {
    setUserPro: (state, action) => {
      state.userPro = action.payload;
    },
  },
});

export const { setUserPro } = userProSlice.actions;

export default userProSlice.reducer;
